module.exports = __webpack_public_path__ + "img/18.33db70c7.webp";